// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pages-info-indexstyleGrid-container-cbchb{margin:0 auto;max-width:1536px;padding:0 12px;width:100%}.pages-info-indexstyleGrid-grid-envff{display:grid;grid-gap:24px;grid-template-columns:repeat(12,1fr)}.pages-info-indexstyleGrid-col6-nbkwn{grid-column:span 6}.pages-info-indexstyleGrid-col3-fycug{grid-column:span 3}.pages-info-indexstyleGrid-col4-bmbvk{grid-column:span 4}.pages-info-indexstyleGrid-col9-bfjmu{grid-column:span 9}.pages-info-indexstyleGrid-col12-bmhvq{grid-column:span 12}.pages-info-indexstyleGrid-alignItemsStart-bdkar{align-items:start}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "pages-info-indexstyleGrid-container-cbchb",
	"grid": "pages-info-indexstyleGrid-grid-envff",
	"col6": "pages-info-indexstyleGrid-col6-nbkwn",
	"col3": "pages-info-indexstyleGrid-col3-fycug",
	"col4": "pages-info-indexstyleGrid-col4-bmbvk",
	"col9": "pages-info-indexstyleGrid-col9-bfjmu",
	"col12": "pages-info-indexstyleGrid-col12-bmhvq",
	"alignItemsStart": "pages-info-indexstyleGrid-alignItemsStart-bdkar"
};
module.exports = ___CSS_LOADER_EXPORT___;
